var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Box"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Glyph",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16.5979C5.13401 16.5979 2 13.4639 2 9.5979C2 5.73191 5.13401 2.5979 9 2.5979C12.866 2.5979 16 5.73191 16 9.5979C16 13.4639 12.866 16.5979 9 16.5979ZM9 5.5979C8.44772 5.5979 8 6.04562 8 6.5979V8.5979C8 9.15019 8.44772 9.5979 9 9.5979C9.55228 9.5979 10 9.15019 10 8.5979V6.5979C10 6.04562 9.55228 5.5979 9 5.5979ZM9 10.5979C8.44772 10.5979 8 11.0456 8 11.5979C8 12.1502 8.44772 12.5979 9 12.5979C9.55228 12.5979 10 12.1502 10 11.5979C10 11.0456 9.55228 10.5979 9 10.5979Z",
    fill: "#E62214"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorInfo);
export default __webpack_public_path__ + "static/media/error_info.d1622f9ba9de9a747843b7dfca289c5a.svg";
export { ForwardRef as ReactComponent };